import LinkTypeModel                  from '@/models/services/website/LinkTypeModel';
import StandPageModel                 from '@/models/services/website/StandPageModel';
import WebsiteServiceModel            from '@/models/WebsiteServiceModel';
import doc                            from '@widesk-core/decorators/doc';

export default class StandPageLinkModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'standPage': id;
		'linkType': id;
		'linkType.reference': Website_LinkTypeReference;
		'search': string;
	};

	private declare _tsSorts: {
		'id': string;
		'linkType.name': string;
		'url': string;
		'position': string;
		'createdAt': string;
		'updatedAt': string;
	};

	static get path(): string {
		return 'stand_page_links/{?id}';
	}

	@doc.model(StandPageModel) declare standPage: StandPageModel;
	@doc.model(LinkTypeModel) declare linkType: LinkTypeModel;
	@doc.string declare url: string;
	@doc.number declare position: number;
}
